@if(mode === 'list') {
    <div class="page">
        <app-page-header [titulo]="presentacion.titulo" [descripcion]="presentacion.descripcion" [icono]="presentacion.icono" [seccion]="presentacion.seccion">
            @if (puedeCrear()) {
                <button type="button" class="btn btn-primary" data-testid="crear" (click)="loadFormConfig('Post')">
                    <i class="bi bi-plus-lg" aria-hidden="true"></i>{{ presentacion.crear }}
                </button>
            }
        </app-page-header>
        @if (listadoPersonalizado) {
            <ng-content></ng-content>
        } @else {
            <app-listado
                [items]="items"
                [type]="type"
                [persistirEstado]="true"
                (openItem)="openItem($event)"
            ></app-listado>
        }
    </div>
}

@if(mode === 'Crear' || mode === 'Editar') {
    <div class="page page--form">
        <button type="button" class="back-link mb-2" (click)="back()"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver</button>
        <app-formulario
            [title]="titleForm"
            [buttons]="buttons"
            [fields]="fields"
            [type]="type"
            [functionSelected]="functionSelected">
        </app-formulario>
    </div>
}
